export function cleanString(input) {
  if (typeof input !== 'string') {
    input = input.toString();
  }
  var output = '';
  for (var i = 0; i < input.length; i++) {
    if (
      input.charCodeAt(i) <= 127 ||
      (input.charCodeAt(i) >= 160 && input.charCodeAt(i) <= 255)
    ) {
      output += input.charAt(i);
    }
  }
  return output;
}
